import * as angular from 'angular';

import { ComponentDefinition } from '../../../../models';
import { IchildApplicationService, ChildApplicationComparison } from '../../../../services';

class ChildrenComparisonPageController implements angular.IComponentController {
    comparisonResult: ChildApplicationComparison[];
    hasOutOfDates: boolean;
    isLoading: boolean;
    loadingMessage: string;

    static $inject = ['childApplicationService'];

    constructor(private _childApplicationService: IchildApplicationService) {
    }

    $onInit() {
        this.isLoading = true;
        this.refesh()
            .finally(() => this.isLoading = false);
    }

    update(results: ChildApplicationComparison[]) {
        this.isLoading = true;
        this.loadingMessage = 'Updating child applications';
        this._childApplicationService
            .updateChildrenApplications(results)
            .then(data => {
                this.comparisonResult = data;
                this.hasOutOfDates = data.filter(d => d.isOutOfDate).length > 0;
            })
            .finally(() => this.isLoading = false);
    }

    private refesh() {
        return this._childApplicationService
            .compare()
            .then(data => {
                this.comparisonResult = data;
                this.hasOutOfDates = data.filter(d => d.isOutOfDate).length > 0;
            });
    }
}

export const wtChildrenComparisonPage: ComponentDefinition = {
    componentId: 'wtChildrenComparisonPage',
    controller: ChildrenComparisonPageController,
    template: require('./childrenComparisonPage.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};